import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
var jwt = require('jwt-simple');
Vue.use(VueAxios, axios)

var authorization = {
  async gentoken (taxid) { 

    const response = await axios.get('https://service-etax.one.th/etaxdatetime/init')
    let tokenSet = response.data.message + "_" + taxid
    let encode = window.btoa(tokenSet)

    const Str = require('@supercharge/strings')
    let random_str1 = Str.random(50)  
    let random_str2 = Str.random(35)  
    let srtEndcod = random_str1+encode+random_str2
    return srtEndcod
    // return encode
  },
  async encodeData (payload) { 
    var payloadJson = JSON.stringify(payload);
    // let encode = window.btoa(payloadJson)
    let encode =  btoa(encodeURIComponent(payloadJson).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
            return String.fromCharCode('0x' + p1);
    }))
    const Str = require('@supercharge/strings')
    let random_str1 = Str.random(50)  
    let random_str2 = Str.random(35)  
    let srtEndcod = random_str1+encode+random_str2
    return srtEndcod
  },
  async decodeDataNew(data) {
    try {
      var decodes = data.split('.');
      var new_decodes = decodes[2].slice(-32);
      decodes[2] = decodes[2].replace(new_decodes, '');
      decodes = decodes[1] + '.' + decodes[2] + '.' + decodes[0];
      var decoded = jwt.decode(decodes, 'bill', false, 'HS256');
      return decoded;
    } catch (err) {
      return data;
    }
  },
}

export default authorization



// WEBPACK FOOTER //
// ./src/components/webportals/authorization/authorization.js